import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "90%",
	maxWidth: "960px",
	bgcolor: "background.paper",
	boxShadow: 24,
};

export default function PopUp({ open, handleClose, children, sx = {} }) {
	let s = { ...style, ...sx };
	return (
		<Modal open={open} onClose={handleClose}>
			<Box>
				<IconButton
					aria-label="close"
					sx={(theme) => ({
						color: "white",
						position: "fixed",
						top: theme.spacing(1),
						right: theme.spacing(1),
					})}
					onClick={handleClose}
				>
					<CloseIcon />
				</IconButton>
				<Box sx={s}>{children}</Box>
			</Box>
		</Modal>
	);
}
